import React from "react";
import {useEntryApp} from "@pages/entry/useEntryApp";
import {CompanyAndName} from "@pages/entry/components/CompanyAndName";
import {InputEmail} from "@pages/entry/components/InputEmail";
import {InputTel} from "@pages/entry/components/InputTel";
import {ProjectDetailSection} from "@pages/entry/components/ProjectDetailSection";
import {InputKenchikuYoto} from "@pages/entry/components/InputKenchikuYoto";
import {ShinsakikanTaionoUmu} from "@pages/entry/components/ShinsakikanTaionoUmu";
import {MitsumoriIraijinoKibonoki} from "@pages/entry/components/MitsumoriIraijinoKibonoki";
import {Attachment} from "@pages/entry/components/Attachment";
import {Agree} from "@pages/entry/components/Agree";
import {Complete} from "@pages/entry/components/Complete";
import {Spinner} from "@components/ui/spinner";

export const EntryApp = () => {

    const {
        company_name,
        your_name,
        email,
        tel,
        project_detail_section,
        project_detail_section_other_text,
        yoto_naiyo1,
        yoto_menseki1,
        shinsakikan_sinseitaio,
        mitsumori_iraijino_kibonoki,
        project_detail_section_options,
        shinsakikan_sinseitaio_options,
        mitsumori_iraijino_kibonoki_options,
        agree,
        errorCount,
        setValue,
        onSubmit,

        company_name_error,
        your_name_error,
        email_error,
        tel_error,
        project_detail_section_error,
        yoto_naiyo1_error,
        yoto_menseki1_error,
        shinsakikan_sinseitaio_error,
        mitsumori_iraijino_kibonoki_error,
        agree_error,
        isProcessing,
        isComplete,

    } = useEntryApp();

    return (
        <>
            {isComplete ? <Complete /> : (
                <div>
                    <p>以下の<span className="re-text">全ての項目</span>を入力し、「送信」ボタンを押してください。</p>
                    <CompanyAndName
                        company_name={company_name}
                        your_name={your_name}
                        company_name_error={company_name_error}
                        your_name_error={your_name_error}
                        setValue={setValue}
                    />
                    <InputEmail email={email} email_error={email_error} setValue={setValue}/>
                    <InputTel tel={tel} tel_error={tel_error} setValue={setValue}/>
                    <ProjectDetailSection
                        options={project_detail_section_options}
                        selected={project_detail_section}
                        sonota_text={project_detail_section_other_text}
                        project_detail_section_error={project_detail_section_error}
                        setValue={setValue}
                    />
                    <InputKenchikuYoto
                        yoto_naiyo1={yoto_naiyo1}
                        yoto_menseki1={yoto_menseki1}
                        yoto_naiyo1_error={yoto_naiyo1_error}
                        yoto_menseki1_error={yoto_menseki1_error}
                        setValue={setValue}
                    />
                    <ShinsakikanTaionoUmu
                        options={shinsakikan_sinseitaio_options}
                        selected={shinsakikan_sinseitaio}
                        shinsakikan_sinseitaio_error={shinsakikan_sinseitaio_error}
                        setValue={setValue}
                    />
                    <MitsumoriIraijinoKibonoki
                        options={mitsumori_iraijino_kibonoki_options}
                        selected={mitsumori_iraijino_kibonoki}
                        mitsumori_iraijino_kibonoki_error={mitsumori_iraijino_kibonoki_error}
                        setValue={setValue}
                    />
                    <Attachment/>
                    <Agree agree={agree} agree_error={agree_error} setValue={setValue}/>

                    {errorCount > 0 && (
                        <div className="form-error-summary">{errorCount}件のエラーが見つかりました</div>
                    )}

                    <button className="submit-btn"
                            type="button"
                            onClick={onSubmit}
                            disabled={isProcessing}
                    >送 信
                    </button>

                    {isProcessing && <Spinner /> }

                </div>
            )}
        </>
    );
};
